module.exports = __webpack_public_path__ + "img/envelope7.474590a2.jpg";